import React from 'react';
import PropTypes from 'prop-types';
import { Pill } from './Pill.styled';
import { looks, sizes } from './Pill.variants';

const PillComponent = ({ children, 'data-testid': dataTestId, look, size }) => (
  <Pill data-testid={dataTestId} look={looks[look]} size={sizes[size]}>
    {children}
  </Pill>
);

PillComponent.propTypes = {
  children: PropTypes.node,
  look: PropTypes.oneOf(Object.keys(looks)),
  size: PropTypes.oneOf(Object.keys(sizes)),
  'data-testid': PropTypes.string,
};

PillComponent.defaultProps = {
  children: undefined,
  look: 'green',
  size: 'default',
  'data-testid': undefined,
};

export default PillComponent;
